import { ToastService } from '@services/common/toast.service';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { QuestionDto } from 'app/@types/dto/question-dto.model';
import { QuestionInstanceInputEntry, inputUpdateMessage } from '../question.component';
import { EnumEntryDto } from 'app/@types/dto/enum-entry-dto.model';
import { CustomTranslateService } from '@services/common/custom-translate.service';

@Component({
    selector: 'app-question-instance',
    templateUrl: './question-instance.component.html',
    styleUrls: ['./question-instance.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class QuestionInstanceComponent {
    @Input() question: QuestionDto;
    @Input() questionInstancesInput: QuestionInstanceInputEntry;
    @Input() domain1Map: Map<string, EnumEntryDto>;
    @Input() domain1: EnumEntryDto[];
    @Input() domainPerCode: { [key: string]: EnumEntryDto[] };
    @Input() locale: string;
    @Input() index: number = -1;
    @Input() id = '';
    @Input() orgId: string;
    @Input() currentEntityFte: number;
    @Input() disabled: boolean;
    @Output() onEnumChange: EventEmitter<QuestionInstanceInputEntry> = new EventEmitter<QuestionInstanceInputEntry>();
    @Output() deleteEntry: EventEmitter<QuestionInstanceInputEntry> = new EventEmitter<QuestionInstanceInputEntry>();
    @Output() onInputEscape: EventEmitter<inputUpdateMessage> = new EventEmitter<inputUpdateMessage>();
    @Output() focusNextInputEvent = new EventEmitter<string>();
    public maxValue1: number | undefined = undefined;
    public maxValue2: number | undefined = undefined;

    constructor(public translateService: CustomTranslateService, private readonly toastService: ToastService) {}

    checkError(event: any, inputField: number) {
        if (this.question.questionCode === 'q015') {
            if (+event.target.ariaValueNow > 52) this.toastService.showError({ details: 'question.q015.error' }, true);
        } else if (this.question.questionCode === 'q016') {
            if (+event.target.ariaValueNow > 5) this.toastService.showError({ details: 'question.q016.error' }, true);
        } else if (this.question.option?.isFTEMax) {
            if (+event.target.ariaValueNow > this.currentEntityFte) {
                this.maxValue1 = this.currentEntityFte;
                this.toastService.showError({ details: 'question.q020a.error' }, true);
            }
        } else if (this.question.questionCode === 'q020a') {
            this.maxValue1 = 100;
            this.maxValue2 = 100;
            const control1 = this.questionInstancesInput.value1Control.value
                ? parseInt(this.questionInstancesInput.value1Control.value, 10)
                : 0;
            const control2 = this.questionInstancesInput.value2Control.value
                ? parseInt(this.questionInstancesInput.value2Control.value, 10)
                : 0;
            if (control1 + control2 > 100) {
                this.toastService.showError({ details: 'question.q020a.error' }, true);
            }
            this.questionInstancesInput.value3Control.setValue(
                100 - control1 - control2 > 0 ? 100 - control1 - control2 : 0,
            );
            if (control1 > 99) {
                this.questionInstancesInput.value2Control.setValue(0);
                this.maxValue2 = 0;
            } else if (control2 > 99) {
                this.questionInstancesInput.value1Control.setValue(0);
                this.maxValue1 = 0;
            } else {
                if (inputField === 1) {
                    this.maxValue1 = 100 - control2;
                    this.maxValue2 = 100 - control1;
                } else {
                    this.maxValue2 = 100 - control1;
                    this.maxValue1 = 100 - control2;
                }
            }
        }
    }

    public notifyEscapeToParent(inputField: number) {
        this.onInputEscape.emit({ inputEntry: this.questionInstancesInput, questionField: inputField });
    }

    public onEnumChangeToParent() {
        this.onEnumChange.emit(this.questionInstancesInput);
    }

    public onDeleteNotif() {
        this.deleteEntry.emit(this.questionInstancesInput);
    }

    focusNextInput(event, id) {
        if (event.key === 'Enter' && id !== '') {
            event.preventDefault();
            this.focusNextInputEvent.emit(id);
        }
    }
}
